import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import {Box, GlobalStyles } from '@mui/material';
import AddReview from './components/addreview/AddReview';
import HomePage from './components/homepage/HomePage';
import NavBar from './components/NavBar';
import Recommendations from './components/recommendations/Recommendations';
import Login from './components/login/Login';
import Register from './components/register/Register';
import Loader from './components/Loader';
import Circle from './components/circle/Circle';
import InstallationGuide from './components/installationguide/InstallationGuide';
import {jwtDecode} from "jwt-decode";
import useNotifications from './components/hooks/useNotifications';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

const Index = () => {
  return  <ThemeProvider theme={theme}> <Router> <App /></Router></ThemeProvider>
}

const App = () => {
  const [loggedUser, setLoggedUser] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [authenticatedUser, setAuthenticatedUser] = useState(null);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const navigate = useNavigate();
  const [notificationsPermissions, notificationsToken, requestNotificationPermission, registerNotificationsToken] = useNotifications();

  useEffect(() => {
    const token = localStorage.getItem('googleAuthToken');
    if(token)
      authenticateUser(token);
  }, []);

  useEffect(() => {
    if (authenticatedUser && idToken && notificationsToken) {
      registerNotificationsToken(idToken);
    }
  }, [authenticatedUser, idToken, notificationsToken]);


  const fetchUser = async (idToken) => {
    try {
      const response = await fetch(`https://script.google.com/macros/s/AKfycbxREPDO9_xArVTVk3trXhFg-u76nPzCES2MoIyBtsUPy7xTGYoNRClNu-AMkltdCSZx/exec?action=getuser&id_token=${idToken}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      if (data.status !== "success"){ 
        throw new Error(data.content);
      }
      setAuthenticatedUser(data.content);
      return data.content;
    } catch (error) {
      console.log("Error fetching user: "+error.message)
      handleLogout(); 
    } 
  }

  const decodeUserData =  (credential) => {
    const decoded = jwtDecode(credential);
    return {email: decoded.email, firstName:decoded.given_name, lastName:decoded.family_name}
  } 
  
  const authenticateUser = async (credential) => {
    setIsAuthenticating(true);
    const loggedUserData = decodeUserData(credential);
    const user = await fetchUser(credential);
    setLoggedUser(loggedUserData);
    setIdToken(credential);
    if (user){
      setIsAuthenticating(false);
      setAuthenticatedUser(user);
      localStorage.setItem('googleAuthToken', credential);

    }else{
      setIsAuthenticating(false);
      navigate("/register");
    }
  };

  const handleLoginFailure = (error) => {
    console.error('Login failed:', error);
  };

  const handleLogout = () => {
    localStorage.clear();
    setLoggedUser(null);
    setAuthenticatedUser(null);
    navigate("/");
  };

  return (
    <>
      {isAuthenticating && <Loader/>}
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            padding: 0,
            boxSizing: 'border-box',
          },
        }}
      />
      <NavBar authenticatedUser={authenticatedUser} showNotificationsEnabler={notificationsPermissions==='default'} requestNotificationPermission={requestNotificationPermission} handleLogout={handleLogout}/>
      <Box sx={{ marginTop: '56px'}}>
        <Routes>
          <Route path="/" element={<HomePage authenticatedUser={authenticatedUser} loginComponent={<Login onSuccess={authenticateUser} onFailure={handleLoginFailure} />}/>} />
          <Route path="/login" element={authenticatedUser ?  <Navigate to="/" /> : <HomePage authenticatedUser={authenticatedUser} loginComponent={<Login onSuccess={authenticateUser} onFailure={handleLoginFailure} />}/>} />
          <Route path="/register" element={loggedUser && !authenticatedUser ?  <Register user={loggedUser} idToken={idToken}/> : <Navigate to="/" /> } />
          <Route path="/recommendations" element={authenticatedUser ? <Recommendations idToken={idToken} /> : <Navigate to="/login" />} />
          <Route path="/addreview" element={authenticatedUser ? <AddReview idToken={idToken} /> : <Navigate to="/login" />} />
          <Route path="/circle" element={authenticatedUser ? <Circle idToken={idToken} /> : <Navigate to="/login" />} />
          <Route path="/installation-guide" element={<InstallationGuide />} /> 
        </Routes>
      </Box>
    </>
  );
};

createRoot(document.getElementById('root')).render(<Index />);